import React from "react";
import { Box, FormGroup } from "@mui/material";
import RequestStatusRow from "./RequestStatusRow";

const RequestStatusSwitch = ({
  isProjectActive,
  onToggleProject,
  projectRequestExists,
  isProjectStatusLoading,
  projectStatusError,
  projectStatusErrorMessage,
  isJobActive,
  onToggleJob,
  jobRequestExists,
  isJobStatusLoading,
  jobStatusError,
  jobStatusErrorMessage,
  disabled = false,
  onClickProjectGuide,
  onClickJobGuide,
}) => {
  const shouldShowProjectGuide =
    !isProjectStatusLoading &&
    !projectStatusError &&
    projectRequestExists === false;

  const shouldShowJobGuide =
    !isJobStatusLoading && !jobStatusError && jobRequestExists === false;

  const shouldShowProjectError = !isProjectStatusLoading && projectStatusError;

  const shouldShowJobError = !isJobStatusLoading && jobStatusError;

  const shouldUseWideRowGap =
    shouldShowProjectGuide ||
    shouldShowJobGuide ||
    shouldShowProjectError ||
    shouldShowJobError;

  const isProjectRequestMissing = projectRequestExists === false;
  const isJobRequestMissing = jobRequestExists === false;

  const isProjectSwitchDisabled = disabled || Boolean(projectStatusError);

  const isJobSwitchDisabled = disabled || Boolean(jobStatusError);

  const lockedOpacity = 0.45;

  const rowStyle = {
    display: "flex",
    alignItems: "center",
    gap: 1,
    width: "100%",
    flexWrap: "wrap",
  };

  const labelStyle = (isRequestMissing) => ({
    width: "140px",
    flexShrink: 0,
    fontSize: "1rem",
    color: "text.primary",
    opacity: isRequestMissing ? lockedOpacity : 1,
  });

  const formControlLabelStyle = {
    m: 0,
    width: "200px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    ".MuiFormControlLabel-label": {
      display: "flex",
      alignItems: "center",
    },
  };

  const rows = [
    {
      key: "project",
      label: "プロジェクト募集",
      isLoading: isProjectStatusLoading,
      isActive: isProjectActive,
      isMissing: isProjectRequestMissing,
      isDisabled: isProjectSwitchDisabled,
      onToggle: onToggleProject,
      showGuide: shouldShowProjectGuide,
      onClickGuide: onClickProjectGuide,
      showError: shouldShowProjectError,
      errorMessage: projectStatusErrorMessage,
    },
    {
      key: "job",
      label: "転職先募集",
      isLoading: isJobStatusLoading,
      isActive: isJobActive,
      isMissing: isJobRequestMissing,
      isDisabled: isJobSwitchDisabled,
      onToggle: onToggleJob,
      showGuide: shouldShowJobGuide,
      onClickGuide: onClickJobGuide,
      showError: shouldShowJobError,
      errorMessage: jobStatusErrorMessage,
    },
  ];

  return (
    <Box>
      <FormGroup
        sx={{
          alignItems: "flex-start",
          gap: shouldUseWideRowGap ? 5 : 1,
        }}
      >
        {rows.map((row) => (
          <RequestStatusRow
            key={row.key}
            label={row.label}
            isLoading={row.isLoading}
            isActive={row.isActive}
            isMissing={row.isMissing}
            isDisabled={row.isDisabled}
            onToggle={row.onToggle}
            showGuide={row.showGuide}
            onClickGuide={row.onClickGuide}
            showError={row.showError}
            errorMessage={row.errorMessage}
            rowStyle={rowStyle}
            labelStyle={labelStyle}
            formControlLabelStyle={formControlLabelStyle}
          />
        ))}
      </FormGroup>
    </Box>
  );
};

export default RequestStatusSwitch;
